import { render } from "./CWidgetProgress.vue?vue&type=template&id=20dc2152"
import script from "./CWidgetProgress.vue?vue&type=script&lang=js"
export * from "./CWidgetProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__